

import React, { createContext, useState } from 'react';


// $FlowFixMe
export const EditableContext = createContext();






export function EditableGroup({ active, children }) {
  const state = useState(active);

  return (
    <EditableContext.Provider value={state}>
      {children}
    </EditableContext.Provider>);

}